// extracted by mini-css-extract-plugin
export default {"container":"Items_container__90wh6","wineImg":"Items_wineImg__zgAvV"};